import GATSBY_COMPILED_MDX from "/home/develop/pxplanding/data/products/feedbackterminal.mdx";
import React from "react";
import {navigate} from "gatsby";
import classnames from "classnames";
import SEO from "../components/seo";
import {Container, Content} from "./../components/container/container";
import * as styles from "./product.module.css";
import {Bar} from "../components/roles-bar";
import MainLayout from "../components/main-layout";
import Header from "../components/new-components/Header/Header";
import FooterDetails from "../components/new-components/Footer/FooterDetails/FooterDetails";
function ProductPage(_ref) {
  let {children, pageContext, location} = _ref;
  React.useEffect(() => {
    window.scrollTo(0, 0);
    if (window.XPress) XPress.render();
  }, []);
  const path = location.pathname.split("/")[1];
  if (path === "products") {
    return React.createElement("div", null, React.createElement("div", {
      style: {
        flex: 1,
        height: "100%"
      }
    }, React.createElement(Header, null), React.createElement(Container, {
      title: React.createElement("h1", {
        className: classnames("header", styles.header)
      }, pageContext.title),
      className: styles.sliderContent,
      containerClassName: styles.container,
      showTopBar: false,
      showBack: false,
      goBack: () => navigate("/" + pageContext.type),
      noCut: true
    }, React.createElement(Content, null, children)), React.createElement(FooterDetails, {
      name: "products",
      section: "Products",
      slug: "/products"
    })));
  } else if (path === pageContext.type) {
    return React.createElement(MainLayout, {
      mode: "products",
      containerClassName: styles.mainContainer,
      HasFooter: true
    }, React.createElement("div", {
      style: {
        flex: 1,
        height: "100%"
      }
    }, React.createElement(Bar, {
      text: "",
      selected: pageContext.title,
      mode: "products",
      goBack: false,
      position: "left",
      style: {
        marginLeft: 41,
        marginTop: 13
      },
      links: pageContext.links.filter(x => x.type === pageContext.type).map(x => ({
        name: x.title,
        slug: x.type + "/products/" + x.slug
      })),
      simple: true,
      reverseColoring: true
    }), React.createElement(Container, {
      title: React.createElement("h1", {
        className: classnames("header", styles.header)
      }, pageContext.title),
      className: styles.sliderContent,
      containerClassName: styles.container,
      showTopBar: false,
      showBack: true,
      goBack: () => navigate("/" + pageContext.type)
    }, React.createElement(Content, null, children))));
  }
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(ProductPage, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const Head = _ref2 => {
  var _pageContext$frontmat, _pageContext$frontmat2;
  let {pageContext} = _ref2;
  return React.createElement(SEO, {
    meta: [{
      name: "keywords",
      content: (_pageContext$frontmat = pageContext.frontmatter.keywords) === null || _pageContext$frontmat === void 0 ? void 0 : _pageContext$frontmat.join(",")
    }],
    title: "" + pageContext.frontmatter.title,
    description: pageContext.frontmatter.description,
    image: (_pageContext$frontmat2 = pageContext.frontmatter.image) === null || _pageContext$frontmat2 === void 0 ? void 0 : _pageContext$frontmat2.publicURL
  });
};
